import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { prioritizeAreas } from "./freelancerCardShared";
import { SearchHighlight } from "./SearchHighlight";
import { containsSearchTerm, type SearchTerm } from "./searchMatch";

interface FreelancerAreasSummaryProps {
  areas: string[] | null | undefined;
  /** Áreas selecionadas no filtro: sobem para o começo da lista. */
  filteredAreas?: string[];
  /** Termo da busca livre: áreas que o contêm sobem e ficam marcadas. */
  searchTerm?: SearchTerm;
  maxVisible: number;
  className?: string;
}

/** Primeiras áreas + "+N"; o tooltip mostra a lista completa. */
export function FreelancerAreasSummary({
  areas,
  filteredAreas = [],
  searchTerm = "",
  maxVisible,
  className,
}: FreelancerAreasSummaryProps) {
  if (!areas || areas.length === 0) return null;

  const ordered = prioritizeAreas(areas, [
    ...filteredAreas,
    ...areas.filter((area) => containsSearchTerm(area, searchTerm)),
  ]);
  const hiddenCount = ordered.length - maxVisible;

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn("flex min-w-0", className)}>
            <span className="truncate">
              <SearchHighlight text={ordered.slice(0, maxVisible).join(", ")} term={searchTerm} />
            </span>
            {hiddenCount > 0 && (
              <span className="shrink-0 whitespace-pre">{` +${hiddenCount}`}</span>
            )}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <ul className="space-y-0.5 text-xs">
            {ordered.map((area) => (
              <li
                key={area}
                className={cn(filteredAreas.includes(area) && "font-semibold")}
              >
                <SearchHighlight text={area} term={searchTerm} />
              </li>
            ))}
          </ul>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
